// src/components/formalities/FormalitiesCategories.jsx
import React, { useEffect, useState } from "react";
import API from "api";

import "./assets/formalities-categories.css";
import Picture from "components/helpers/Picture/Picture";

export default function FormalitiesCategories({ onSelectCategory }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    loadCategories();
  }, []);
  const loadCategories = async () => {
    try {
      setLoading(true);
      const res = await API.get("/formalities/categories");
      setCategories(res.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    return (
      <div className="text-center py-3 text-muted">
        Chargement…
      </div>
    );
  }
  return (
    <div className="row g-4">
      {categories.map((cat) => (
        <div
          key={cat.fcId}
          className="col-12 col-md-6 col-lg-6 col-xl-4"
        >
          <div
            className="formalities-category-card"
            style={{ cursor: "pointer" }}
            onClick={() => onSelectCategory(cat)}
          >
            <div className="formalities-category-header" >
              <Picture
                src={`/msmedias/.formalities/assets/${cat.fcCover}`}
                w={400}
              />
            </div>
            <div className="formalities-category-body py-3 px-5" >
              <div className="formalities-category-name"><span className="badge badge-sm bg-primary rounded-pill fw-normal mb-2 px-3">{cat.fcName}</span></div>
              <div className="formalities-category-summary text-center text-muted small">{cat.fcSummary}</div>

            </div>
            <div className="formalities-category-icon-wrapper">

            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
